module.exports = __webpack_public_path__ + "h5/img/money-icon.667ff36c.png";